import { Directive, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { Asset } from '@zero/shared/util-models';
import { OrderFormGroup, QuantityType } from '@zero/trade/domain';

@Directive()
export abstract class TradeCreateHintBase implements OnChanges, OnDestroy {
  @Input() public form!: FormGroup<OrderFormGroup>;
  @Input() public mode!: QuantityType;
  @Input() public asset?: Asset;
  @Input() public errors?: ValidationErrors | null;

  @Output() public allowedToProceedOrderChange = new EventEmitter<void>();
  @Output() public experienceCheckCanceled = new EventEmitter();

  public hasSpecialTradingHours = false;
  public tradingHours?: string;

  public get quantity(): AbstractControl {
    return this.form.get('quantityForm')?.get('quantity');
  }

  public get orderValue(): AbstractControl {
    return this.form.get('orderValue');
  }

  public ngOnChanges(): void {
    if (!this.asset) {
      this.reset();
      return;
    }

    this.setup();
  }

  public ngOnDestroy(): void {
    this.reset();
  }

  public updateExperienceAndFtgOK = (allowedToProceed: boolean): void => {
    this.asset.experienceAndFtgOK = allowedToProceed === true ? 'OK' : 'NOK';
    this.allowedToProceedOrderChange.emit();
  };

  private setup = (): void => {
    this.setTradingHours();
  };

  private reset = (): void => {
    this.hasSpecialTradingHours = false;
    this.tradingHours = undefined;
  };

  protected abstract setTradingHours(): void;
}
